import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=c4537bf0&scoped=true&"
import script from "./agent.vue?vue&type=script&lang=js&"
export * from "./agent.vue?vue&type=script&lang=js&"
import style0 from "./agent.vue?vue&type=style&index=0&id=c4537bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4537bf0",
  null
  
)

export default component.exports